<template>
    <div class="servers-page">
        <servers-maintenance :customers="customers"/>

        <!-- <deployments-panel
            :customers="customers"
            :active-deployments="activeDeployments"
            :is-deploying="isDeploying"
            :selected-environment.sync="selectedEnvironment"
            @start="startDeployment"
            @stop="stopDeployment"
        /> -->

        <system-logs
            :show="showLogs && !!currentBuildId"
            :build-id="currentBuildId"
            :environment="selectedEnvironment"
            :is-live="isLogsActive"
            :logs="deploymentLogs"
            @close="showLogs = false"
        />
    </div>
    </template>

<script>
import ServersMaintenance from '@/components/servers/ServersMaintenance.vue'
import DeploymentsPanel from '@/components/servers/DeploymentsPanel.vue'
import SystemLogs from '@/components/tools/SystemLogs.vue'
export default {
    name: 'servers-page',
        components: { ServersMaintenance, DeploymentsPanel, SystemLogs },
    data () {
        return {
            devTestEndpoint: 'https://api-test.nubbo.io',
            branch: null,
            customer: null,
            updating: false,
            importing: false,
            container: 'devtest',
            containers: [
                {label: 'devtest', value: 'devtest'},
                {label: 'nubbo', value: 'nubbo'},
            ],
            customers: [
                {label: 'Raja Tours Indonesia', value: 'raja'},
                {label: 'Argentina On The Go', value: 'aotg'},
                {label: 'Designer Trips', value: 'dstrip'},
                {label: 'Innovart Tours', value: 'innova'},
                {label: 'New World Travel Designers', value: 'nwtd'},
                {label: 'Mater Sustentable', value: 'mater'},
                {label: 'Quarum Travel', value: 'quarum'},
                {label: 'Signagures DMC', value: 'signa'},
                {label: 'Demo', value: 'demo'},
                {label: 'Test', value: 'test'},
            ],
            selectedEnvironment: '',
            isDeploying: false,
            activeDeployments: {},
            deploymentLogs: [],
            currentBuildId: null,
            showLogs: false,
            nextLogToken: null,
            statusPolling: null,
            logsPolling: null,
            logsInFlight: false,
            lastStatus: null,
            terminalSince: null,
            idleEmptyCount: 0,
        }
    },
    async mounted () {
        try {
            await this.loadActiveDeployments();
        } catch (error) {
            console.error('Error during component mount:', error);
        }
    },
    beforeDestroy() {
        this.clearPolling();
    },
    computed: {
        isLogsActive() {
            return !!(this.statusPolling || this.logsPolling);
        }
    },
    methods: {
        async startDeployment () {
            if (!this.selectedEnvironment) return;
            this.isDeploying = true;
            try {
                const res = await api.post('/api/deployment2/start_deployment', JSON.stringify({
                    environment: this.selectedEnvironment
                }),{ 'Content-Type': 'application/json' });
                const data = res;
                if (!data.success) throw new Error(data.error || 'Failed to start');

                this.currentBuildId = data.build_id;
                this.showLogs = true;
                this.deploymentLogs = [];
                this.nextLogToken = null;
                this.startPolling();
            } catch (e) {
                console.error(e);
                this.notify('error', 'Error', e.message || 'Failed to start deployment');
            } finally {
                this.isDeploying = false;
            }
        },
        async stopDeployment(environment) {
            const deployment = this.activeDeployments[environment];
            if (!deployment) return;

            try {
                const response = await api.post(`/api/deployment2/stop_deployment/${deployment.build_id}`);
                
                if (response.success) {
                    alert(`${this.tr('Deployment stopped for')} ${environment}`);
                }
            } catch (error) {
                alert(`Error: ${error.response?.error || error.message}`);
            }
        },
        async loadActiveDeployments() {
            try {                
                const response = await api.get('/api/deployment2/active_deployments');
                this.activeDeployments = response || {};

                if (Object.keys(this.activeDeployments).length > 0) {
                    this.startPolling();
                }
            } catch (error) {
                console.error('Error loading active deployments:', error);
                this.activeDeployments = {};
            }
        },
        async updateDeploymentStatus () {
            if (!this.currentBuildId) return;
            try {
                const res = await api.get(`/api/deployment2/deployment_status/${encodeURIComponent(this.currentBuildId)}`);
                const data = res;

                if (data && data.success) {
                    if (data.status !== this.lastStatus) {
                        this.lastStatus = data.status;
                        if (['SUCCEEDED', 'FAILED', 'STOPPED', 'TIMED_OUT'].includes(data.status)) {
                            if (!this.terminalSince) this.terminalSince = Date.now();
                            this.notify(
                                data.status === 'SUCCEEDED' ? 'success' : 'error',
                                'Deployment Finished',
                                `${data.environment || ''}: ${data.status}`
                            );
                            this.clearPolling()
                        }
                    }
                }
            } catch (e) {
                console.error('status error', e);
            }
        },
        async updateDeploymentLogs () {
            const isTerminal = !!this.terminalSince
            if (this.logsInFlight) return;
            if (!this.currentBuildId || !this.showLogs) return;

            this.logsInFlight = true;
            try {
                const q = this.nextLogToken ? `?next_token=${encodeURIComponent(this.nextLogToken)}` : '';
                const res = await api.get(`/api/deployment2/deployment_logs/${encodeURIComponent(this.currentBuildId)}${q}`);
                const data = res;

                if (typeof data.next_token !== 'undefined' && data.next_token !== this.nextLogToken) {
                    this.nextLogToken = data.next_token;
                }

                if (data.success && Array.isArray(data.logs) && data.logs.length) {
                    this.deploymentLogs = [...data.logs];
                    this.idleEmptyCount = 0;
                } else {
                    this.idleEmptyCount++;
                    if (isTerminal && data && data.has_more === false && this.idleEmptyCount >= 2) {
                        this.clearPolling();
                        return;
                    }
                }
            } catch (e) {
                console.error('logs error', e);
            } finally {
                this.logsInFlight = false;
            }
        },
        startPolling () {
            this.clearPolling();
            this.statusPolling = setInterval(this.updateDeploymentStatus, 2000);
            this.logsPolling = setInterval(this.updateDeploymentLogs, 2000);
            this.updateDeploymentStatus();
            this.updateDeploymentLogs();
        },
        clearPolling () {
            if (this.statusPolling) {
                clearInterval(this.statusPolling);
                this.statusPolling = null;
            }
            if (this.logsPolling) {
                clearInterval(this.logsPolling);
                this.logsPolling = null;
            }
            this.logsInFlight = false;
        },
        notify (type, title, text) {
            if (this.$notify) {
                this.$notify({ type, title, text });
            } else {
                console.log(`[${type}] ${title}: ${text}`);
            }
        },
        tr(key) {
            if (window.tr && typeof window.tr === 'function') {
                return window.tr(key);
            }
            if (this.$t && typeof this.$t === 'function') {
                return this.$t(key);
            }
            return key;
        }
    }
}
</script>